import * as React from 'react';
import 'react-virtualized/styles.css'; // only needs to be imported once
import { selectMachinesWithValidLocations } from 'state/ducks/location/reducer';
import { localized } from 'state/i18n';
import { useAppSelector } from 'utilities/hooks';

const LocationsShown: React.FC = () => {
	const machines = useAppSelector(state => selectMachinesWithValidLocations(state));

	return (
		<div className="flex-wrap flex-center-row">
			<span className="white-space-nowrap">{(machines?.length ?? 0) + ' ' + localized('UnitsShown')}</span>
		</div>
	);
};

export default LocationsShown;
